import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ColorsModule } from '@plugins/client/colors/colors.module';

import { ButtonComponent } from './button.component';

@NgModule({
  declarations: [ButtonComponent],
  imports: [CommonModule, ColorsModule],
  exports: [ButtonComponent],
})
export class ButtonModule {}
export { ButtonComponent };
